import { gsePricingApi } from 'app/services/api';

import { toInlineError } from '../marginCenter.actionUtils';
import {
  GSE_HELD_PULLS_PAGE_SIZE,
  GSE_PULL_REVIEW_DECISION,
  GSE_PULL_STATUS,
} from '../marginCenter.constants';
import { mapHeldPullToView } from '../marginCenter.mappers';

import { getDeskStatusAction } from './deskStatus.actions';

// The Freddie held-pulls review list is read and reviewed by the card that shows it, so these thunks
// return the outcome ({ data, error }) and keep nothing in the store. Errors (a 403 without the
// feed-admin claim, a 409 guard refusal) are returned for the card to show inline.

export const readHeldPullsAction =
  ({ includeMarketClosed = false, page = 1 } = {}) =>
  async () => {
    try {
      const { data, totalCount } = await gsePricingApi.getPulls({
        status: GSE_PULL_STATUS.QUARANTINED,
        reviewed: false,
        includeMarketClosed,
        page,
        pageSize: GSE_HELD_PULLS_PAGE_SIZE,
      });

      return {
        data: { items: (data ?? []).map(mapHeldPullToView), totalCount },
        error: null,
      };
    } catch (error) {
      return { data: null, error: toInlineError(error) };
    }
  };

// After a promote or discard the desk status re-reads, so the held count, the base feed age and the
// status line everywhere in Margin Center agree with the list.
export const reviewHeldPullAction =
  ({ gsePricingPullId, decision, note = null }) =>
  async dispatch => {
    try {
      const body = { note: note || null };
      const { data } =
        decision === GSE_PULL_REVIEW_DECISION.PROMOTE
          ? await gsePricingApi.promotePull(gsePricingPullId, body)
          : await gsePricingApi.discardPull(gsePricingPullId, body);

      await dispatch(getDeskStatusAction());

      return { data: data ? mapHeldPullToView(data) : null, error: null };
    } catch (error) {
      return { data: null, error: toInlineError(error) };
    }
  };
